import {Map as ImmutableMap} from "immutable";
import {getConfig} from "./envUtil";

export const handleEnter = (cb: () => any) => (event: any) => {
    if (event.key === "Enter") {
        cb();
    }
};

export function mapToArrayWithRoundNumbers<T>(map: ImmutableMap<T, number>, digits: number)
    : { value: string; key: T }[] {

    return map.map((numValue, key) => {
        return {key, value: numValue.toFixed(digits)};
    }).valueSeq().toArray();
}

export function groupBy(objectsArray: any[], groupByProperty: string, valueProperty: string)
    : ImmutableMap<any, number> {
    return objectsArray.reduce((acc, holding) => {
        const value = isNaN(holding[valueProperty])
            ? 0
            : holding[valueProperty];
        const key = holding[groupByProperty];
        if (acc.has(key)) {
            return acc.set(key, (acc.get(key) + value));
        } else {
            return acc.set(key, value);
        }
    }, ImmutableMap<any, number>());
}

export const isNullOrUndefined = (value: any): value is null | undefined => {
    return value === null || value === undefined;
};

export const capitalizeFirstLetter = (str: string) => {
    return str.toLowerCase().split(" ")
        .map((word: string) => word.substr(0, 1).toUpperCase() + word.substr(1))
        .join(" ");
};

export const getConfigPageSize = () => {
    const parsedSize = parseInt(getConfig().FRONTEND_CONFIG_PAGE_SIZE, 10);

    return isNaN(parsedSize) ? 20 : parsedSize;
};

export const trimToNearestWord = (subject: string, limit: number) => {
    if (subject.length <= limit) {
        return subject;
    }
    const temp = subject.substr(0, limit);

    return temp.lastIndexOf(" ") === -1
    ? temp
    : temp.substr(0, Math.min(temp.length, temp.lastIndexOf(" ")));
};


export const getNumber = (value: any): number => {
    return isNaN(value) ? 0.00 : +(Number(value).toFixed(2));
};

export const isValidUrl = (url: string): boolean => {
    if (!url || /\s/.test(url)) return false;
    if (!/^https?:\/\//.test(url)) return false;
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return false;

        const hostname = parsed.hostname;
        if (!hostname || hostname.includes("..")) return false;

        const labels = hostname.split(".");
        if (labels.length < 2) return false;
        if (labels[0].toLowerCase() === "www" && labels.length < 3) return false;

        const labelRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
        for (const label of labels) {
            if (!label || !labelRegex.test(label)) return false;
        }

        const tld = labels[labels.length - 1];
        return /^[a-zA-Z]{2,}$/.test(tld);
    } catch {
        return false;
    }
};
